import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getTenantId, getDepartmentId } from 'src/app/services/store-snapshot.service';
import { IdName } from 'src/app/shared/models/id-name';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { FormDataService } from 'src/app/shared/attachments/service/form-data.service';
import {
  IStandardJobTemplateRequest,
  IStandardJobTemplateResponse,
  IApiResponseGroupStandardJobTemplates,
  IStandardJobTemplateFromList,
} from '../models/standard-job-template.model';

@Injectable({
  providedIn: 'root',
})
export class StandardJobTemplateApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/${getDepartmentId()}/StandardJobTemplates`;
  }

  constructor(private http: HttpClient) {}

  loadStandardJobTemplates(
    currentFilter?: MainTableFilterModel
  ): Observable<IApiResponseGroupStandardJobTemplates> {
    let params = createFilterParams(currentFilter);
    if (currentFilter?.additional) {
      params = params.set('MenuId', currentFilter.additional);
    }
    return this.http.get<IApiResponseGroupStandardJobTemplates>(this.url, { params });
  }

  loadAllStandardJobTemplates(): Observable<IStandardJobTemplateFromList[]> {
    const url = `${this.url}/List`;
    return this.http.get<IStandardJobTemplateFromList[]>(url);
  }

  loadStandardJobTemplateById(id: string): Observable<IStandardJobTemplateResponse> {
    const url = `${this.url}/${id}`;
    return this.http.get<IStandardJobTemplateResponse>(url);
  }

  loadStandardJobTemplateVersionById(
    id: string,
    versionId: string
  ): Observable<IStandardJobTemplateResponse> {
    const url = `${this.url}/${id}/${versionId}`;
    return this.http.get<IStandardJobTemplateResponse>(url);
  }

  createStandardJobTemplate(jobTemplate: IStandardJobTemplateRequest): Observable<IdName> {
    const formData = FormDataService.mapToFormData(jobTemplate);
    return this.http.post<IdName>(this.url, formData);
  }

  updateStandardJobTemplate(jobTemplate: IStandardJobTemplateRequest): Observable<void> {
    const formData = FormDataService.mapToFormData(jobTemplate);
    const url = `${this.url}/${jobTemplate.id}`;
    return this.http.put<void>(url, formData);
  }

  deleteStandardJobTemplate(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
